import core = egr.wcf.core;
import { GlobalHelper } from './GlobalHelper';
import { ToolsActions } from '../actions/ToolsActions';
import { SceneActions } from '../actions/SceneActions';

export abstract class CameraHelper {
    private static storedDefaultCameraModes: Map<core.view.View, core.view.CameraMode> = new Map();

    public static createView(pViewPort: BABYLON.Viewport, pMode: core.view.CameraMode): core.view.View {
        const tView: core.view.View = new core.view.View(GlobalHelper.coreApp.viewer, pViewPort);
        GlobalHelper.coreApp.viewer.addView(tView);
        ToolsActions.setCamera(pMode, tView);
        CameraHelper.storedDefaultCameraModes.set(tView, pMode);
        return (tView);
    }

    public static setCameraMode(mode: core.view.CameraMode, view?: core.view.View): void {
        if (view == null) {
            view = GlobalHelper.activeView;
        }
        view.cameraControl.cameraMode = mode;

        if (GlobalHelper.articleManager.session.isValid) {
            GlobalHelper.articleManager.synchronizeSession(true);
        }
        SceneActions.setActiveView(); /* called to trigger SceneStore update */
    }

    public static resetCameras(): void {
        CameraHelper.storedDefaultCameraModes.forEach((mode: core.view.CameraMode, view: core.view.View, map) => {
            view.cameraControl.resetCamera(true, true);
            view.cameraControl.cameraMode = mode;
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/CameraHelper.ts